/* eslint-disable import/prefer-default-export */
import buildEnum from 'utils/buildEnum';

export const fieldIds = buildEnum(
  ['program', 'location'],
  key => `inboundProgram.${key}`,
);



// WEBPACK FOOTER //
// ./src/compositions/CaseInboundProgramPanel/constants.js